import { render, staticRenderFns } from "./Antibacterial.vue?vue&type=template&id=2b6c70de&"
import script from "./Antibacterial.vue?vue&type=script&lang=js&"
export * from "./Antibacterial.vue?vue&type=script&lang=js&"
import style0 from "./Antibacterial.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports